"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    KeySolid: function() {
        return KeySolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const KeySolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M16.0002 1C12.1342 1 9.00019 4.13401 9.00019 8C9.00019 8.31836 9.02151 8.63228 9.06292 8.94028C9.09317 9.16527 9.11193 9.30608 9.12184 9.40871C9.1236 9.42701 9.12485 9.44204 9.12574 9.45414L9.11684 9.464C9.06813 9.51749 8.99814 9.58784 8.87221 9.71376L1.76171 16.8243L1.72556 16.8603C1.59091 16.9942 1.42137 17.1629 1.29491 17.3692C1.18525 17.5482 1.10444 17.7433 1.05545 17.9473C0.998953 18.1827 0.999592 18.4218 1.0001 18.6117L1.00019 18.6627L1.00019 20.4319C1.00016 20.6843 1.00013 20.9301 1.01714 21.1382C1.03581 21.3668 1.07988 21.6366 1.21818 21.908C1.40992 22.2843 1.71589 22.5903 2.09221 22.782C2.36363 22.9203 2.63337 22.9644 2.86196 22.9831C3.07008 23.0001 3.31582 23 3.56816 23L6.00019 23C6.55248 23 7.00019 22.5523 7.00019 22V21H8.00019C8.55248 21 9.00019 20.5523 9.00019 20V19H10.0002C10.5525 19 11.0002 18.5523 11.0002 18V17H12.0002C12.2654 17 12.5198 16.8946 12.7073 16.7071L14.2864 15.128C14.4124 15.0021 14.4827 14.9321 14.5362 14.8833L14.5461 14.8745C14.5582 14.8753 14.5732 14.8766 14.5915 14.8784C14.6941 14.8883 14.8349 14.907 15.0599 14.9373C15.3679 14.9787 15.6818 15 16.0002 15C19.8662 15 23.0002 11.866 23.0002 8C23.0002 4.13401 19.8662 1 16.0002 1ZM16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9H16.01C16.5623 9 17.01 8.55228 17.01 8C17.01 7.44772 16.5623 7 16.01 7H16Z",
        fill: "currentColor"
    })
}), "KeySolid");
const _default = KeySolid;
